<template>
  <div class="section pb-10" style="overflow-x:hidden;">
    <router-view :user="user"></router-view>
    <help-button></help-button>
    <b-modal
      id="welcome-modal"
      centered
      content-class="welcomeModalClass"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-title>
        <div class="welcomeModalTitle">
          Welcome to My Pfizer Studies
        </div>
      </template>
      <div class="d-block welcomeModalText">
        My Pfizer Studies provides timely and transparent site and study level information. With
        dashboards such as Start Up or Enrollment, you can view overall study progress and/or help
        identify next steps for your site. Thank you for your ongoing partnership in the pursuit of
        breakthroughs that change patients’ lives.
      </div>
      <div class="d-block welcomeModalText mt-3">
        By accessing My Pfizer Studies, your first name, last name and email address tied to your
        third party log in credentials (eg Exostar) will be shared with Pfizer, Inc. and used for
        the sole purpose of validating your use of My Pfizer Studies. For additional information as
        to Pfizer's privacy practices, please review
        <a href="https://www.pfizer.com/privacy" target="_blank">here</a>.
      </div>
      <p class="welcomeModalText mt-3">
        Your use of My Pfizer Studies is governed by the following
        <a href="/terms-of-use" target="_blank">Terms Of Use</a>.
      </p>
      <template #modal-footer>
        <b-button pill variant="primary" @click="agree">Continue</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props: {
      user: Object,
    },
    mounted() {
      let tourIsShown = localStorage.getItem('new_welcome_popup_approved');
      if (!tourIsShown) {
        this.$bvModal.show('welcome-modal');
      }
    },
    methods: {
      agree() {
        localStorage.setItem('new_welcome_popup_approved', '1');
        this.$bvModal.hide('welcome-modal');
      },
    },
  };
</script>

<style scoped>
  .welcomeModalText {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #46464f;
  }

  .welcomeModalTitle {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
  }

  .welcomeModalClass {
    border-radius: 24px;
    -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  }
</style>
